import React from "react";
import { TwitterAuthProvider, signInWithPopup, getAuth } from "@firebase/auth";
import { app } from "./firebase";
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from "../../store/authStore";
import { BsTwitterX } from "react-icons/bs";
import { useAlert } from "../../context/AlertContext";


export default function TwitterAuth() {
    const navigate = useNavigate();
    const { setTokens } = useAuthStore();
    const setAlert = useAlert();

    const handleTwitterClick = async () => {
        try {
            const provider = new TwitterAuthProvider();
            const auth = getAuth(app);
            const result = await signInWithPopup(auth, provider);

            console.log("Twitter result", result);

            // Check if email is missing and synthesize one using UID if needed
            const email = result.user.email || `${result.user.uid}@twitter.local`;

            // Parse displayName into firstName and lastName
            let firstName = 'User';
            let lastName = 'User';

            if (result.user.displayName) {
                const nameParts = result.user.displayName.trim().split(' ');
                firstName = nameParts[0] || 'User';
                lastName = nameParts.slice(1).join(' ') || nameParts[0] || 'User'; // Fallback to first name or 'User' if no space exists
            }

            const res = await fetch(`https://hellocer-backend.onrender.com/api/auth/twitter`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    firstName,
                    lastName,
                    email: email,
                    profilePicture: result.user.photoURL || null,
                }),
            });

            const response = await res.json();
            console.log(response);

            if (response.success) {
                const { accessToken, refreshToken, user } = response;
                const { role } = response.user;

                setTokens({
                    accessToken,
                    refreshToken,
                    role,
                    user
                });

                if (setAlert) {
                    setAlert({ type: 'success', message: `Welcome ${response.user.firstName}!` });
                }
                navigate('/clients/dashboard');
            } else {
                if (setAlert) {
                    setAlert({ type: 'error', message: response.error || 'Twitter login failed' });
                }
            }
        } catch (error) {
            console.log("Could not login with Twitter", error);
            if (setAlert) {
                setAlert({ type: 'error', message: 'Twitter login failed' });
            }
        }
    }


    return (

          <button
              type="button"
              onClick={handleTwitterClick}
              className="w-full md:w-1/2 flex items-center justify-center py-3 px-4 border border-[#666464] hover:bg-gray-50 transition-colors"
            >
                <BsTwitterX color="#666464" className="w-5 h-5 mr-2"/>
              Log in with X
            </button>
    )
}